import type { LedgerYear } from '../types'

import { defineStore } from 'pinia'

import { SfLog } from '@app/adapters/logger'
import SFetch from '@app/utils/sfetch'

// `-1` is the not-yet-loaded sentinel. Once data is fetched, `currentLedgerId`
// holds the resolved ledger id, or `null` when the active ledger is
// invalid/archived (no period should be highlighted in that case).
const NOT_LOADED = -1

export const usePeriodPicker = defineStore('periodPicker', {
  state: (): {
    currentLedgerId: number | null
    ledgersPerYear: number
    isLoading: boolean
    years: LedgerYear[]
  } => ({
    currentLedgerId: NOT_LOADED,
    ledgersPerYear: 0,
    isLoading: false,
    years: [],
  }),
  actions: {
    async requestData(url: string) {
      try {
        this.isLoading = true

        const data = (await SFetch.json(url, {
          method: 'GET',
        })) as {
          currentLedgerId: number | null
          ledgersPerYear: number
          years: LedgerYear[]
        }

        this.currentLedgerId = data.currentLedgerId
        this.ledgersPerYear = data.ledgersPerYear
        this.years = data.years
      } catch (err) {
        SfLog.warn('Error fetching period picker data', {
          extra: {
            error: err,
          },
        })
      } finally {
        this.isLoading = false
      }
    },
  },
  getters: {
    hasRequiredData(state): boolean {
      return (
        !state.isLoading &&
        state.currentLedgerId !== NOT_LOADED &&
        state.years.length > 0
      )
    },
  },
})
